import React, { useEffect, useState } from "react";
import AuthService from "../../../../services/User/AuthService";
import NoticeService from "../../../../services/User/NoticeService";
import HttpError from "../../../../utill/HttpError";
import Swal from "sweetalert2";

const alertStyle = {
  backgroundColor: "#7000ff",
  border: "1px solid #ff0000",
  color: "#fff",
  padding: "15px",
  margin: "20px",
  borderRadius: "5px",
  fontFamily: "Poppins, sans-serif",
  lineHeight: "1.5",
};

const ImportantNote = () => {
  const [noteHtml, setNoteHtml] = useState("");

  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const token = AuthService.getAccessToken();
        const responseData = await NoticeService.fetchFlashMessage(token);

        const { status, message, data } = responseData;

        if (status === "SUCCESS") {
          const uti_flash_message = data?.uti_flash_message || [];

          setNoteHtml(uti_flash_message);
        } else {
          Swal.fire("Oops!", message, "error");
        }
      } catch (error) {
        Swal.fire("Oops!", HttpError.getError(error), "error");
      }
    };

    fetchNotice();
  }, []);

  if (!noteHtml) return null;

  return (
    <div style={alertStyle}>
      <div dangerouslySetInnerHTML={{ __html: noteHtml }} />
    </div>
  );
};

export default ImportantNote;
